import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { CatalogLadle } from "../models/CatalogLadle";

export const getCatalogLadles = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[STEEL].[GetLadles]", []);
};

export const upsertCatalogLadle = async (ladle: CatalogLadle) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];
  parameters.push({ name: "LadleId", value: ladle.LadleId });
  parameters.push({ name: "LadleName", value: ladle.LadleName });
  parameters.push({ name: "Enabled", value: ladle.Enabled });
  parameters.push({ name: "IsActive", value: ladle.IsActive });

  return await apiService.callV2("[STEEL].[UpsertLadle]", parameters);
};

export const deleteCatalogLadle = async (LadleId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];

  parameters.push({ name: "LadleId", value: LadleId });

  return await apiService.callV2("[STEEL].[DeleteLadle]", parameters);
};
